import buildTextInputDefinition, {
    TextInputDefinition
} from "../../../../../../../../utils/forms/models/grid-fields/text-input-definition";
import buildTextAreaDefinition, {
    TextAreaDefinition
} from "../../../../../../../../utils/forms/models/grid-fields/text-area-definition";
import buildHiddenInputDefinition, {
    HiddenInputDefinition
} from "../../../../../../../../utils/forms/models/grid-fields/hidden-input-definition";
import { FormDefinition } from "../../../../../../../../utils/forms/builders/build-form-grid-fields";

enum SCHEMA_NAMES {
    ID = "id",
    DESCRIPTION = "description",
    NAME = "name"
}

const UUID: HiddenInputDefinition = buildHiddenInputDefinition({
    name: "uuid",
    placeholder: "uuid",
    id: "GroupConfigUUID",
    label: "UUID",
    schemaName: "uuid",
    fieldOverrides: { formSpacing: false }
});

const ID_INPUT: HiddenInputDefinition = buildHiddenInputDefinition({
    name: "id",
    placeholder: "ID",
    id: "GroupConfigID",
    label: "ID",
    schemaName: SCHEMA_NAMES.ID,
    fieldOverrides: { formSpacing: false }
});

const NAME_INPUT: TextInputDefinition = buildTextInputDefinition({
    name: "name",
    placeholder: "Name",
    id: "GroupConfigName",
    label: "Name",
    schemaName: SCHEMA_NAMES.NAME,
    fieldOverrides: { formSpacing: false }
});

const DESCRIPTION_INPUT: TextAreaDefinition = buildTextAreaDefinition({
    name: "description",
    placeholder: "Description",
    id: "GroupConfigDescription",
    label: "Terminal Group Description",
    disabled: false,
    schemaName: SCHEMA_NAMES.DESCRIPTION
});

export const TERMINAL_GROUP_DEFINITION: FormDefinition = {
    [SCHEMA_NAMES.ID]: {
        definition: {
            ...ID_INPUT,
            fieldOverrides: {
                formSpacing: false
            }
        },
        order: 0
    },
    [SCHEMA_NAMES.NAME]: {
        definition: {
            ...NAME_INPUT,
            fieldOverrides: {
                formSpacing: false,
                columnClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"
            }
        },
        order: 1
    },
    [SCHEMA_NAMES.DESCRIPTION]: {
        definition: {
            ...DESCRIPTION_INPUT,
            fieldOverrides: {
                formSpacing: false,
                columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            }
        },
        order: 2
    },
    ["uuid"]: {
        definition: UUID,
        order: 3
    }
};
